module.exports = __webpack_public_path__ + "assets/django.da233e2d.svg";